import { render, staticRenderFns } from "./ServicesHome.vue?vue&type=template&id=6f06cfb5&scoped=true"
import script from "./ServicesHome.vue?vue&type=script&lang=js"
export * from "./ServicesHome.vue?vue&type=script&lang=js"
import style0 from "./ServicesHome.vue?vue&type=style&index=0&id=6f06cfb5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f06cfb5",
  null
  
)

export default component.exports